import React, { useState } from "react";
import { Modal, Button, Row, Col, Typography } from "antd";
import { ReactComponent as DownloadSvg } from "../../../assets/images/download.svg";
import BulkFileUpload from "../../../components/common/upload-file/BulkFileUpload";
import { toast } from "react-toastify";
import axios from "axios";
import { getUserData } from "../../../redux/action/user-management/userManagementAction";
import { useDispatch } from "react-redux";

const { Title, Text } = Typography;

const BulkUploadModal = ({ open, onClose }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();
  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URI}/tenant/user/bulk`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_API_KEY,
            Authorization: `Bearer ${localStorage.getItem("ACCESS_TOKEN")}`,
          },
        }
      );

      if (res?.data?.code === 200) {
        toast.success(res?.data?.message || "Upload successful!");
        dispatch(getUserData());

        onClose();
        setSelectedFile(null);
      } else {
        toast.error(res?.data?.message || "Upload failed!");
      }
    } catch (error) {
      console.log(error);

      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={[
        <Button
          key="confirm"
          onClick={handleUpload}
          type="primary"
          className="confirm-btn"
          disabled={!selectedFile}
        >
          {"Upload User Data"}
        </Button>,
      ]}
      className="custom-confirm-modal"
    >
      <div className="changePassword">
        <Row gutter={16} className="signin-row">
          <Col xs={24} sm={24}>
            <div className="cflex">
              <div className="leftContainer">
                <Title level={2}>Bulk Users Upload</Title>
                <Text className="subtitle mb-2">
                  In order to upload the users data in bulk you need to use the
                  below template.
                </Text>
                <div className="downloadBtn mb-2">
                  <Button
                    type="default"
                    icon={<DownloadSvg />}
                    style={{
                      border: "1px solid #FFA600",
                      color: "#FFA600",
                      backgroundColor: "transparent",
                    }}
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = "/templates/podcast_user.csv";
                      link.download = "user_template.csv";
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >
                    Download Template
                  </Button>
                </div>
                <BulkFileUpload setUploadedFile={setSelectedFile} />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default BulkUploadModal;
